








































import {Component, Prop, Vue} from "vue-property-decorator";
import {CompanyDTO} from "@/dto/CompaniesDTO";
import RegexUtils from "@/utils/RegexUtils";

@Component
export default class CompanyModal extends Vue{

    private message: string | null = null;

    @Prop()
    private onSave!: () => void

    @Prop()
    private company! : CompanyDTO

    saveData(){
        this.message = null;

        this.$validator.validate().then((isValid) => {
            if (isValid) {
                this.onSave();
                this.closeModal();
            }else {
                this.message = "Fill required fields"
            }
        });
    }

    closeModal(){
        this.$modal.hideAll();
    }

    handleEin(event: any) {
        let current = this.company.ein ? this.company.ein : "";
        if (RegexUtils.testEinPreSeparator(current)) {
            current = current.concat('-')
            this.company.ein = current;
        }
        const next = (current).concat(event.key);
        if (!RegexUtils.testEin(next)) {
            event.preventDefault();
        }
    }

}
